module.exports = __webpack_public_path__ + "img/bus.960801f1.png";